import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';

export const AdminTalkRoutes: RouteRecordRaw[] = [
    {
        path: '',
        component: wrapRuntimeImport(() => import('./screens/landing.vue')),
        meta: { admin: true }
    },
    {
        path: 'overview',
        component: wrapRuntimeImport(() => import('./screens/overview.vue')),
        meta: { admin: true }
    },
    {
        path: 'numbers',
        component: wrapRuntimeImport(() => import('./screens/numbers.vue')),
        meta: { admin: true }
    },
    {
        path: 'numbers/buy',
        component: wrapRuntimeImport(() => import('./screens/numbers/buy.vue')),
        meta: { admin: true }
    },
    {
        path: 'numbers/port',
        component: wrapRuntimeImport(() => import('./screens/numbers/port.vue')),
        meta: { admin: true }
    },
    {
        path: 'endpoints',
        component: wrapRuntimeImport(() => import('./screens/endpoints.vue')),
        meta: { admin: true }
    },
    {
        path: 'endpoints/hardware',
        component: wrapRuntimeImport(() => import('./screens/hardware.vue')),
        meta: { admin: true }
    },
    {
        path: 'endpoints/hardware/orders',
        component: wrapRuntimeImport(() => import('./screens/hardware-orders.vue')),
        meta: { admin: true }
    },
    {
        path: 'call-flows',
        component: wrapRuntimeImport(() => import('./screens/call-flows.vue')),
        meta: { admin: true }
    },
    {
        path: 'ring-groups',
        component: wrapRuntimeImport(() => import('./screens/ring-groups.vue')),
        meta: { admin: true }
    },
    {
        path: 'time-conditions',
        component: wrapRuntimeImport(() => import('./screens/time-conditions.vue')),
        meta: { admin: true }
    },
    {
        path: 'parking-lots',
        component: wrapRuntimeImport(() => import('./screens/parking-lots.vue')),
        meta: { admin: true }
    },
    {
        path: 'caller-routes',
        component: wrapRuntimeImport(() => import('./screens/caller-routes.vue')),
        meta: { admin: true }
    },
    {
        path: 'outbound-routes',
        component: wrapRuntimeImport(() => import('./screens/outbound-routes.vue')),
        meta: { admin: true }
    },
    {
        path: 'ai-agents',
        component: wrapRuntimeImport(() => import('./screens/ai-agents.vue')),
        meta: { admin: true }
    },
    {
        path: 'hold-music',
        component: wrapRuntimeImport(() => import('./screens/hold-music.vue')),
        meta: { admin: true }
    },
    {
        path: 'greetings',
        component: wrapRuntimeImport(() => import('./screens/greetings.vue')),
        meta: { admin: true }
    }
];
